import React, { createContext, useContext, useState, useEffect, useCallback, useMemo } from 'react';
import { submissionsApi } from './api/Submission';

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(() => {
    const storedAuth = localStorage.getItem('access_token');
    return storedAuth ;
  });
  const [hasProfile, setHasProfile] = useState(null); // null = loading, true/false = result

  const checkProfile = useCallback(async () => {
    try {
      console.log('Checking profile...');
      const profile = await submissionsApi.getInstitutionProfile();
      console.log('Profile check result:', profile);
      const profileExists = Boolean(profile?.id);
      console.log('Profile exists:', profileExists);
      setHasProfile(profileExists);
      return profileExists;
    } catch (error) {
      console.log('Profile check error:', error);
      setHasProfile(false);
      return false;
    }
  }, []);

  const login = async (response) => {
    // Handle new RMS response format
    const tokenData = response.data || response;
    localStorage.setItem('access_token', tokenData.access_token);
    localStorage.setItem('refresh_token', tokenData.refresh_token);
    localStorage.setItem('user', JSON.stringify(tokenData.user));
    localStorage.setItem('expires_in', tokenData.expires_in);
    setAuth(tokenData);
    // Check if user has profile after login
    await checkProfile();
  };

  const logout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user');
    setAuth(null);
    setHasProfile(null);
    window.location.href = '/authentiate';
  };

  // Check profile on app load if authenticated
  useEffect(() => {
    if (auth && hasProfile === null) {
      checkProfile();
    }
  }, [auth, hasProfile, checkProfile]);

  const contextValue = useMemo(() => ({ 
    auth,
    login, 
    logout,
    checkProfile,
    isAuthenticated: !!auth,
    hasProfile,
    role: auth?.role || null
  }), [auth, login, logout, checkProfile, hasProfile]);

  return (
    <AuthContext.Provider value={contextValue}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};